import { Method } from 'axios';
import { Executable } from './executable';

/**
 * The UploadFromUrlInput used by the constructor of UploadFromUrl
 */
export interface UploadFromUrlInput {
  /**
   * The url to download the data from
   */
  url: string;
}

/**
 * The UploadFromUrl response expected from the execution of the object within BambuClient execute.
 */
export interface UploadFromUrlResponse {
  /**
   * the uploaded data ipfs url
   */
  ipfsUrl: string;
  /**
   * the message response from the request in case of errors
   */
  message?: string;
  /**
   * any error messages that were returned by the request.
   */
  error?: any;
}

export class UploadFromUrl extends Executable<UploadFromUrlResponse> {
  public payload: UploadFromUrlInput;

  /**
   * getMethod is used by the BambuClient to properly construct the request call.
   * @returns request method
   */
  public getMethod(): Method {
    return 'post';
  }

  /**
   * getResponse is used by the BambuClient to propery return the response object type.
   * @param apiResponse the api response object returned by the BambuMeta client before being converted to the UploadFromUrlResponse
   * @returns UploadFromUrlResponse
   */
  public getResponse(apiResponse: any): UploadFromUrlResponse {
    return apiResponse;
  }

  /**
   * getURLPath is used by the BambuClient to properly construct the request call.
   * @param tenantId the tenant id defined in the BambuClient
   * @returns request url
   */
  public getURLPath(tenantId?: string): string {
    return `${tenantId}/files/upload-from-url`;
  }

  constructor(input: UploadFromUrlInput) {
    super();
    this.payload = input;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): any {
    const input = this.payload;
    return input;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return undefined;
  }
}
